<template>
  <div class="com-box" :class="{'comBoxMargin':creationMode }">
    <div class="com-title" v-if="creationMode">基础设置</div>
    <div class="com-content title-box" :class="{'comContentMargin':creationMode }">
      <van-field
        class="text-input"
        required
        v-model="form.activityTitle"
        label="活动标题"
        label-width="70px"
        :maxlength="14"
        placeholder="请输入活动标题(最多14个字)"
        @blur="onFormChange"
      />
      <van-cell v-if="isModifying" title="活动时间" class="time-cell text-input">
        <div class="date-box">
          <div>
            <span class="date-val">{{form.startTime | shorDay}}</span>
            <van-icon name="edit" size="16" v-if="!isRunning && !isEnd" @click="showCalendarSingle('startTime')"/>
          </div>
          <span>-</span>
          <div>
            <span class="date-val">{{form.endTime | shorDay}}</span>
            <van-icon name="edit" size="16" v-if="!isEnd" @click="showCalendarSingle('endTime')"/>
          </div>
        </div>
      </van-cell>
      <van-field
        v-else
        class="text-input"
        required
        readonly
        v-model="timeDisp"
        label="活动时间"
        label-width="13em"
        placeholder="请选择时间"
        @click="showCalendar"
      >
        <van-icon name="arrow" slot="right-icon" class="input-right-icon" />
      </van-field>
    </div>

    <van-calendar 
      v-model="isShowCalendar" 
      :default-date="defaultDateRange"
      type="range" 
      color="#FF6B31" 
      allow-same-day 
      get-container="body"
      @confirm="onCalendarConfirm" />

    <van-calendar 
      v-model="isShowCalendarSingle" 
      :default-date="defaultDate"
      color="#FF6B31" 
      :show-confirm="false"
      :max-date="maxDate"
      get-container="body"
      @confirm="onCalendarSingleConfirm" />
  </div>
</template>

<script>
import moment from 'moment'
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Object,
    isModifying: Boolean,
    createdTime: [String, Number],
  },
  computed: {
    // 活动进行中
    isRunning() {
      return this.$route.query.activeTab == 2;
    },
    isEnd() {
      return this.$route.query.activeTab == 3;
    },
    // 组件创建方式
    creationMode() {
      return this.$route.query.creationMode != 'new' ? true : false
    }
  },
  data() {
    return {
      isShowCalendar: false,
      // 选择单个日期
      isShowCalendarSingle: false,
      timeDisp: '',
      defaultDateRange: [],
      defaultDate: null,
      form: {
        activityTitle: '',
        startTime: '',
        endTime: ''
      },
      // 当前的日期字段
      currentDateField: '',
      withdrawConfig: {},
      maxDate: new Date(moment().add(6, 'months').calendar())
    }
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.initForm(newVal);
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.queryPublicityData()
  },
  methods: {
    initForm(val) {
      if (val) {
        this.form = {...val};
        this.timeDisp = `${this.formatDate(val.startTime)} - ${this.formatDate(val.endTime)}`;
        this.defaultDateRange = [moment(val.startTime).toDate(), moment(val.endTime).toDate()]
      }
    },
    onFormChange() {
      this.$emit('change', this.form);
    },
    showCalendar() {
      this.isShowCalendar = true;
    },
    // type: 1开始 2结束
    showCalendarSingle(fieldName) {
      this.currentDateField = fieldName;
      // if (this.creationMode) {
        this.defaultDate = this.form[fieldName] ? moment(this.form[fieldName]).toDate() : null;
        const { time } = this.withdrawConfig
        const isNewActive = new Date(this.createdTime).getTime() < new Date(time).getTime()
        // 旧活动 活动结束时间不能大于当前活动结束时间
        if (fieldName === 'endTime' && isNewActive)  {
          this.maxDate = new Date(this.form.endTime)
        }
      // }
      this.isShowCalendarSingle = true;
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      return moment(date).format('M/D')
    },
    onCalendarConfirm(range) {
      const [start, end] = range;
      this.form.startTime = moment(start).format('YYYY-MM-DD');
      this.form.endTime = moment(end).format('YYYY-MM-DD');
      this.isShowCalendar = false;
      this.onFormChange();
    },
    onCalendarSingleConfirm(date) {
      // 开始不能大于结束
      if (this.currentDateField === 'startTime') {
        const startTime = moment(date).startOf('d').valueOf();
        const endTime = moment(this.form.endTime).startOf('d').valueOf();
        if (startTime > endTime) {
          this.$toast('开始日期不能大于结束日期');
          return;
        }
      }
      // 结束不能大于开始
      if (this.currentDateField === 'endTime') {
        const startTime = moment(this.form.startTime).startOf('d').valueOf();
        const endTime = moment(date).startOf('d').valueOf();
        if (endTime < startTime) {
          this.$toast('结束日期不能小于开始日期');
          return;
        }
      }

      this.form[this.currentDateField] = moment(date).format('YYYY-MM-DD');
      this.isShowCalendarSingle = false;
      this.onFormChange();
    },
    checkValid() {
      let invalidLabels = [];
      for (const [key, value] of Object.entries(this.form)) {
        if (key === 'activityTitle' && !value) {
          invalidLabels.push('活动标题');
        } else if (key === 'startTime' && !value) {
          invalidLabels.push('活动时间');
        }
      }

      invalidLabels = [...new Set(invalidLabels)];
      if (invalidLabels.length) {
        this.$notify({
          message: `${invalidLabels.join('、')}不能为空`,
          type: 'warning'
        });
        return false;
      }
      return true;
    },
    queryPublicityData(){
      this.$api.h5.queryPublicityData('wx_withdraw_config')
        .then(res => {
          if (res.success) {
            const {storeStaffSelect, time} = res.data
            this.withdrawConfig = {storeStaffSelect,time}
          }
          
        })
    }
  },
  filters: {
    shorDay(val) {
      if (!val) {
        return '';
      }
      return moment(val).format('M/D')
    }
  }
}
</script>

<style lang="stylus" scoped>
.com-box
  .com-title
    padding 0 15px
    font-size 14px
    font-weight bold
    color #303133
  .com-content
    // margin 10px 15px
    padding 15px 15px 5px
    background-color: #fff
    border-radius: 8px

    .text-input
      padding 10px 7px
      >>> .van-field__body input
        color $mainTextColor
      &::before
        left -2px
        bottom 7px

    .time-cell
      >>> .van-cell__title
        flex none
        margin-right 12px
        width 70px
        color #646566
      .date-box
        display: flex
        justify-content: space-between
        align-items: center
        width 70%
        .date-val
          color $mainTextColor
          margin-right 5px

  .title-box
    padding 0 15px
  .comContentMargin {
    margin: 10px 15px;
  }
.comBoxMargin {
  margin: 15px 0;
}

</style>